export const isE2ETest = () => global.document.cookie.includes('e2e-test');
